import React, { useState, useEffect } from "react";
import { ContainerCrear } from "../../../components/ContainerCrear";
import RolService from "../../../services/RolService";
import { useHistory } from "react-router-dom";
import { useContext } from "react";
import { SecurityContext } from "../../../context/SecurityContextProvider";
import { Form, Input, Row, Col, Button, notification, Space, Switch, Checkbox, Collapse, Divider } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { CampoColaborador } from "enums/CampoColaborador";
import produce from "immer";
import { OPCIONES } from "enums";
import ParametrosService from "services/ParametrosService";

const ACCIONES = [
    {
        opcionPadre: "consulta.documento",
        datos: Object.values(OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS),
    },
    {
        opcionPadre: "notificacion.seguimiento.v2",
        datos: Object.values(OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES),
    },
    {
        opcionPadre: "notificacion.seguimiento.v2.ver-detalle",
        datos: Object.values(OPCIONES.PAGINA_DETALLE_NOTIFICACION),
    },
    {
        opcionPadre: "legajo.v2.consultas",
        datos: Object.values(OPCIONES.PAGINA_CONSULTAR_POR_CARPETAS),
    },
];

export function RolCrearPage() {
    // const [opcionesSeleccionadas, setOpcionesSeleccionadas] = useState([]);
    const [estadoAprobador, setEstadoAprobador] = useState(false);
    const [loading, setLoading] = useState(false);
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const [porCompletar, setPorCompletar] = useState([]);
    //const [checkedList, setCheckedList] = useState([]);
    const [indeterminateMantenimiento, setIndeterminateMantenimiento] = useState(false);
    const [indeterminateNotificacion, setIndeterminateNotificacion] = useState(false);
    const [indeterminateContrato, setIndeterminateContrato] = useState(false);
    const [indeterminateLegajos, setIndeterminateLegajos] = useState(false);
    const [indeterminateConfiguracion, setIndeterminateconfiguracion] = useState(false);
    const [indeterminateVacaciones, setIndeterminateVacaciones] = useState(false);
    const [indeterminateComunicacionCultura, setIndeterminateComunicacionCultura] = useState(false);

    const [checkAllMantenimiento, setCheckAllMantenimiento] = useState(false);
    const [checkAllNotificacion, setCheckAllNotificacion] = useState(false);
    const [checkAllContrato, setCheckAllContrato] = useState(false);
    const [checkAllLegajos, setCheckAllLegajos] = useState(false);
    const [checkAllConfiguracion, setCheckAllConfiguracion] = useState(false);
    const [checkAllVacaciones, setCheckAllVacaciones] = useState(false);
    const [checkAllComunicacionCultura, setCheckAllComunicacionCultura] = useState(false);

    const [opcionesSeleccionadasMantenimiento, setOpcionesSeleccionadasMantenimiento] = useState([]);
    const [opcionesSeleccionadasNotificaciones, setOpcionesSeleccionadasNotificaciones] = useState([]);
    const [opcionesSeleccionadasContratos, setOpcionesSeleccionadasContratos] = useState([]);
    const [opcionesSeleccionadasLegajos, setOpcionesSeleccionadasLegajos] = useState([]);
    const [opcionesSeleccionadasConfiguracion, setOpcionesSeleccionadasConfiguracion] = useState([]);
    const [opcionesSeleccionadasVacaciones, setOpcionesSeleccionadasVacaciones] = useState([]);
    const [opcionesSeleccionadasComunicacionCultura, setOpcionesSeleccionadasComunicacionCultura] = useState([]);

    const [opcionesNotificacion, setOpcionesNotificacion] = useState([]);
    const [campoPerfil, setCampoPerfil] = useState(undefined);
    const [campoSede, setCampoSede] = useState(undefined);
    const [campoSubsede, setCampoSubsede] = useState(undefined);
    const [campoSeccion, setCampoSeccion] = useState(undefined);
    const [campoTipoPlanilla, setCampoTipoPlanilla] = useState(undefined);
    const [campoCargo, setCampoCargo] = useState(undefined);

    const [accionesSeleccionadas, setAccionesSeleccionadas] = useState([]);

    let history = useHistory();
    const { Panel } = Collapse;

    useEffect(() => {
        async function cargarDatos() {
            const consulta = await ParametrosService.notificacionCompletarActivo(
                getUsuarioAutenticado().empresaSeleccionada.id
            );
            setPorCompletar(consulta);

            if (consulta) {
                opcionesNotificacionesAlternativo.push("notificacion.completar");
                opcionesNotificaciones.push("notificacion.completar");
            }
            if (
                getUsuarioAutenticado().subdominio.includes("ingenioti") === false &&
                getUsuarioAutenticado().subdominio.includes("antalis") === false &&
                getUsuarioAutenticado().subdominio.includes("demo") === false
            ) {
                setOpcionesNotificacion(opcionesNotificaciones);
            } else {
                setOpcionesNotificacion(opcionesNotificacionesAlternativo);
            }
            const campos_colaborador = getUsuarioAutenticado().empresaSeleccionada.camposColaborador;

            campos_colaborador.map((item) => {
                if (item.campo === CampoColaborador.PERFIL) {
                    setCampoPerfil(item);
                } else if (item.campo === CampoColaborador.SEDE) {
                    setCampoSede(item);
                } else if (item.campo === CampoColaborador.SUBSEDE) {
                    setCampoSubsede(item);
                } else if (item.campo === CampoColaborador.SECCION) {
                    setCampoSeccion(item);
                } else if (item.campo === CampoColaborador.PLANILLA) {
                    setCampoTipoPlanilla(item);
                } else if (item.campo === CampoColaborador.CARGO) {
                    setCampoCargo(item);
                }
            });

            setAccionesSeleccionadas(
                produce((draft) => {
                    ACCIONES.forEach((accion) => {
                        //const accionesRol = rol.opciones.filter((opcion) => accion.datos.includes(opcion));
                        //if (accionesRol === undefined) {
                        draft.push({ opcionPadre: accion.opcionPadre, datos: [] });
                        //} else {
                        //  draft.push({ opcionPadre: accion.opcionPadre, datos: accionesRol });
                        //}
                    });
                })
            );
        }
        cargarDatos();
    }, []);

    async function handleOnFinish(rol) {
        try {
            setLoading(true);
            var opciones_ = [
                ...opcionesSeleccionadasMantenimiento.slice(),
                ...opcionesSeleccionadasNotificaciones.slice(),
                ...opcionesSeleccionadasContratos.slice(),
                ...opcionesSeleccionadasLegajos.slice(),
                ...opcionesSeleccionadasConfiguracion.slice(),
                ...opcionesSeleccionadasVacaciones.slice(),
                ...opcionesSeleccionadasComunicacionCultura.slice(),
            ];

            accionesSeleccionadas.forEach((accionSeleccionada) => {
                opciones_ = [...opciones_, ...accionSeleccionada.datos];
            });

            //setOpcionesSeleccionadas(opciones_);
            rol.empresaId = getUsuarioAutenticado().empresaSeleccionada.id;
            rol.opciones = opciones_;
            rol.aprobador = estadoAprobador;
            await RolService.insertar(rol);
            notification.success({
                message: "Operación exitosa",
                description: "Se registró el rol correctamente.",
            });
            setLoading(false);
            history.push("/rol");
        } catch (error) {
            console.error(error);
            notification.error({
                message: "No se puede registrar el Rol",
                description: error.response.data.mensaje,
            });
            setLoading(false);
        }
    }

    const opcionesMantenimiento = [
        "mantenimiento",
        "mantenimiento.sede",
        "mantenimiento.cargo",
        "mantenimiento.colaborador",
        "mantenimiento.usuario",
        "mantenimiento.rol",
        "mantenimiento.seccion",
        "mantenimiento.subsede",
        "mantenimiento.perfil",
        "mantenimiento.tipoPlanilla",
        "mantenimiento.colaborador.reporte.ver-sueldo",
        "mantenimiento.colaborador.editar.ver-sueldo",
        "mantenimiento.colaborador.editar.numero-documento-identidad"
    ];

    let opcionesMantenimientoVisibles = opcionesMantenimiento;
    if (campoSede === undefined || campoSede.visible === false) {
        opcionesMantenimientoVisibles = opcionesMantenimientoVisibles.filter(
            (opcion) => opcion !== "mantenimiento.sede"
        );
    }
    if (campoPerfil === undefined || campoPerfil.visible === false) {
        opcionesMantenimientoVisibles = opcionesMantenimientoVisibles.filter(
            (opcion) => opcion !== "mantenimiento.perfil"
        );
    }
    if (campoSubsede === undefined || campoSubsede.visible === false) {
        opcionesMantenimientoVisibles = opcionesMantenimientoVisibles.filter(
            (opcion) => opcion !== "mantenimiento.subsede"
        );
    }
    if (campoSeccion === undefined || campoSeccion.visible === false) {
        opcionesMantenimientoVisibles = opcionesMantenimientoVisibles.filter(
            (opcion) => opcion !== "mantenimiento.seccion"
        );
    }
    if (campoTipoPlanilla === undefined || campoTipoPlanilla.visible === false) {
        opcionesMantenimientoVisibles = opcionesMantenimientoVisibles.filter(
            (opcion) => opcion !== "mantenimiento.tipoPlanilla"
        );
    }
    if (campoCargo === undefined || campoCargo.visible === false) {
        opcionesMantenimientoVisibles = opcionesMantenimientoVisibles.filter(
            (opcion) => opcion !== "mantenimiento.cargo"
        );
    }

    const opcionesNotificaciones = [
        "notificacion",
        "notificacion.crear",
        //"notificacion.seguimiento",
        "notificacion.seguimiento.formularios",
        "notificacion.comunicados.crear",
        //"notificacion.completar"
        "notificacion.evaluacion",
    ];

    const opcionesNotificacionesAlternativo = [
        "notificacion",
        "notificacion.crear",
        //"notificacion.seguimiento",
        "notificacion.seguimiento.formularios",
        "notificacion.comunicados.crear",
        "notificacion.evaluacion",
        "notificacion.firma-documento-generico",
        "notificacion.firma-documento-generico.crear",
        "notificacion.firma-documento-generico.listar",
        "notificacion.firma-documento-generico.bandeja-aprobador",
    ];
    // if(porCompletar){
    //   opcionesNotificacionesAlternativo.push("notificacion.completar")
    //   opcionesNotificaciones.push("notificacion.completar")
    // }
    const opcionesContrato = [
        "contrato",
        "contrato.crear",
        "contrato.seguimiento",
        "contrato.registrarPlantilla",
        "explomin.contrato.seguimiento.administracionpersonal",
        "explomin.contrato.seguimiento.rys",
    ];

    const opcionesLegajos = [
        "legajos",
        "legajos.consultas",
        "legajo.v2.consultas",
        "notificacion.seguimiento.v2",
        "consulta.documento",
        "legajos.observacionesColaborador",
        "legajos.consultaOnboarding",
        "legajos.seguimientoOnboarding",
        "legajos.reportes",
        //"ausencias.solicitudes",
        //"vacaciones.control-vacacional",
        "legajos.seguimientoEvaluaciones",
        "consulta.seguimientoContrato",
    ];
    const opcionesConfiguracion = [
        "configuracion",
        "configuracion.formularios",
        "configuracion.misCertificados",
        "configuracion.MiFirmaHolografa",
        "configuracion.certificadosDigitales",
        "configuracion.tipoDocumentos",
        "configuracion.carpetasLegajos",
        "configuracion.verficarDatosColaborador",
        "configuracion.plantillaEnvioDocumentos",
        "configuracion.documentosSolicitables",
        "configuracion.onBoardingIndividual",
        "configuracion.posicionesPdf",
        //"configuracion.tipoAbsentismo",
    ];

    const opcionesVacaciones = [
        "vacaciones-y-ausencias",
        "configuracion.tipoAbsentismo",
        "ausencias.solicitudes",
        "vacaciones.control-vacacional",
        "vacaciones.descanso-medico",
        "programar.vacaciones",
        "compra.vacaciones",
        "vacaciones-y-ausencias.ausencias.solicitudes.crear-solicitud",
        "vacaciones-y-ausencias.ausencias.solicitudes.exportar-solicitudes",
        "vacaciones-y-ausencias.ausencias.solicitudes.habilitar-restricciones-solicitudes",
    ];

    const opcionesComunicacionCultura = [
        "comunicacion-cultura",
        "comunicacion-cultura.publicaciones",
        "comunicacion-cultura.reconocimientos",
        "comunicacion-cultura.beneficios-externos",
        "comunicacion-cultura.puntos",
        "comunicacion-cultura.rendimiento",
        "comunicacion-cultura.beneficios",
    ];
    // function handleOnChangeOpciones(targetKeys, direction, moveKeys) {
    //   setOpcionesSeleccionadas(targetKeys);
    //   //console.log("targetKeys",targetKeys);
    // }

    function handleOnClickCancelar() {
        history.push("/rol");
    }
    function onChangeAprobador(value) {
        setEstadoAprobador(value);
    }
    function onCheckTodosMantenimiento(e) {
        setOpcionesSeleccionadasMantenimiento(
            // e.target.checked ? opcionesMantenimiento : []
            e.target.checked ? opcionesMantenimientoVisibles : []
        );
        setIndeterminateMantenimiento(false);
        setCheckAllMantenimiento(e.target.checked);
    }
    function onChangeOpcionMantenimiento(lista) {
        if (lista.length > 0) {
            lista.push("mantenimiento");
            setOpcionesSeleccionadasMantenimiento(lista);
        } else {
            setOpcionesSeleccionadasMantenimiento(lista);
        }
        setIndeterminateMantenimiento(
            //!!lista.length && lista.length < opcionesMantenimiento.length
            !!lista.length && lista.length < opcionesMantenimientoVisibles.length
        );
        //setCheckAllMantenimiento(lista.length === opcionesMantenimiento.length);
        setCheckAllMantenimiento(lista.length === opcionesMantenimientoVisibles.length);
    }
    function onCheckTodosNotificacion(e) {
        setOpcionesSeleccionadasNotificaciones(e.target.checked ? opcionesNotificacion : []);
        setIndeterminateNotificacion(false);
        setCheckAllNotificacion(e.target.checked);
        //console.log("listaTodos", opcionesSeleccionadasNotificaciones);
        //console.log("CheckedTodos",opcionesNotificacion);
    }
    function onChangeOpcionNotificacion(lista) {
        if (lista.length > 0) {
            lista.push("notificacion");
            setOpcionesSeleccionadasNotificaciones(lista);
        } else {
            setOpcionesSeleccionadasNotificaciones(lista);
        }
        setIndeterminateNotificacion(!!lista.length && lista.length < opcionesNotificacion.length);
        setCheckAllNotificacion(lista.length === opcionesNotificacion.length);
    }
    function onCheckTodosContrato(e) {
        setOpcionesSeleccionadasContratos(e.target.checked ? opcionesContrato : []);
        setIndeterminateContrato(false);
        setCheckAllContrato(e.target.checked);
    }
    function onChangeOpcionContrato(lista) {
        if (lista.length > 0) {
            lista.push("contrato");
            setOpcionesSeleccionadasContratos(lista);
        } else {
            setOpcionesSeleccionadasContratos(lista);
        }
        setIndeterminateContrato(!!lista.length && lista.length < opcionesContrato.length);
        setCheckAllContrato(lista.length === opcionesContrato.length);
    }
    function onCheckTodosLegajos(e) {
        setOpcionesSeleccionadasLegajos(e.target.checked ? opcionesLegajos : []);
        setIndeterminateLegajos(false);
        setCheckAllLegajos(e.target.checked);
    }
    function onChangeOpcionLegajo(lista) {
        if (lista.length > 0) {
            lista.push("legajos");
            setOpcionesSeleccionadasLegajos(lista);
        } else {
            setOpcionesSeleccionadasLegajos(lista);
        }
        setIndeterminateLegajos(!!lista.length && lista.length < opcionesLegajos.length);
        setCheckAllLegajos(lista.length === opcionesLegajos.length);
    }
    function onCheckTodosConfiguracion(e) {
        setOpcionesSeleccionadasConfiguracion(e.target.checked ? opcionesConfiguracion : []);
        setIndeterminateconfiguracion(false);
        setCheckAllConfiguracion(e.target.checked);
    }
    function onChangeOpcionConfiguracion(lista) {
        if (lista.length > 0) {
            lista.push("configuracion");
            setOpcionesSeleccionadasConfiguracion(lista);
        } else {
            setOpcionesSeleccionadasConfiguracion(lista);
        }
        setIndeterminateconfiguracion(!!lista.length && lista.length < opcionesConfiguracion.length);
        setCheckAllConfiguracion(lista.length === opcionesConfiguracion.length);
    }

    const onCheckTodosVacaciones = (e) => {
        setOpcionesSeleccionadasVacaciones(e.target.checked ? opcionesVacaciones : []);
        setIndeterminateVacaciones(false);
        setCheckAllVacaciones(e.target.checked);
    };

    const onChangeOpcionVacaciones = (lista) => {
        if (lista.length > 0) {
            lista.push("vacaciones-y-ausencias");
            setOpcionesSeleccionadasVacaciones(lista);
        } else {
            setOpcionesSeleccionadasVacaciones(lista);
        }
        setIndeterminateVacaciones(!!lista.length && lista.length < opcionesVacaciones.length);
        setCheckAllVacaciones(lista.length === opcionesVacaciones.length);
    };

    const onCheckTodosComunicacionCultura = (e) => {
        setOpcionesSeleccionadasComunicacionCultura(e.target.checked ? opcionesComunicacionCultura : []);
        setIndeterminateComunicacionCultura(false);
        setCheckAllComunicacionCultura(e.target.checked);
    };

    const onChangeOpcionComunicacionCultura = (lista) => {
        if (lista.length > 0) {
            lista.push("comunicacion-cultura");
            setOpcionesSeleccionadasComunicacionCultura(lista);
        } else {
            setOpcionesSeleccionadasComunicacionCultura(lista);
        }
        setIndeterminateComunicacionCultura(!!lista.length && lista.length < opcionesComunicacionCultura.length);
        setCheckAllComunicacionCultura(lista.length === opcionesComunicacionCultura.length);
    };

    const onChangeAccionesSeleccionadas = (opcionesSeleccionadas, opcionPadre) => {
        setAccionesSeleccionadas(
            produce((draft) => {
                //const todasLasAcciones = ACCIONES.find((accion) => accion.opcionPadre === opcionPadre).datos;
                const accion = draft.find((opcion) => opcion.opcionPadre === opcionPadre);
                if (accion) {
                    accion.datos = opcionesSeleccionadas;
                } else {
                    draft.push({
                        opcionPadre: opcionPadre,
                        datos: opcionesSeleccionadas,
                    });
                }
            })
        );
    };

    const onChangeSeleccionarSubMenu = (submenu) => {
        setAccionesSeleccionadas(
            produce((draft) => {
                if (submenu.target.checked === false) {
                    const accionSeleccionada = draft.find((accion) => accion.opcionPadre === submenu.target.value);
                    accionSeleccionada.datos = [];
                } else {
                    const todasLasAcciones = ACCIONES.find(
                        (accion) => accion.opcionPadre === submenu.target.value
                    ).datos;
                    const accionSeleccionada = draft.find((accion) => accion.opcionPadre === submenu.target.value);
                    accionSeleccionada.datos = todasLasAcciones;
                }
            })
        );
    };

    return (
        <ContainerCrear titulo="Crear Rol" descripcion="Crear un rol dentro de tu organización." colSpan={12}>
            <Form layout="vertical" size="large" onFinish={handleOnFinish}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label="Nombre:"
                            name="nombre"
                            rules={[
                                {
                                    required: true,
                                    message: "Ingrese el nombre del rol",
                                },
                            ]}
                        >
                            <Input placeholder="Escribe el nombre del rol" autoComplete="off" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item label="Aprobador:" name="aprobador">
                            <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                onChange={onChangeAprobador}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Collapse defaultActiveKey={["1"]}>
                    <Panel header="Opciones" key="1">
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateMantenimiento}
                                onChange={onCheckTodosMantenimiento}
                                checked={checkAllMantenimiento}
                                style={{ color: "#1678c1" }}
                            >
                                MANTENIMIENTO
                            </Checkbox>
                        </Row>

                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group
                                    //options={plainOptions}
                                    // value={checkedList}
                                    value={opcionesSeleccionadasMantenimiento}
                                    onChange={onChangeOpcionMantenimiento}
                                >
                                    <Row>
                                        {campoSede !== undefined && campoSede.visible === true && (
                                            <Col span={24}>
                                                <Checkbox value="mantenimiento.sede">Centro de costo</Checkbox>
                                            </Col>
                                        )}
                                        {campoCargo !== undefined && campoCargo.visible === true && (
                                            <Col span={24}>
                                                <Checkbox value="mantenimiento.cargo">Cargo</Checkbox>
                                            </Col>
                                        )}
                                        <Col span={24}>
                                            <Checkbox value="mantenimiento.colaborador">Colaborador</Checkbox>
                                        </Col>
                                        <Col span={1}>
                                        </Col>
                                        <Col span={23}>
                                            <Checkbox
                                                value={
                                                    OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR
                                                        .TXT_EDITAR_VER_SUELDO
                                                }
                                            >
                                                Editar ver sueldo
                                            </Checkbox>
                                        </Col>
                                        <Col span={1}>
                                        </Col>
                                        <Col span={23}>
                                            <Checkbox
                                                value={
                                                    OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR
                                                        .TXT_REPORTE_VER_SUELDO
                                                }
                                            >
                                                Reporte ver sueldo
                                            </Checkbox>
                                        </Col>
                                        <Col span={1}>
                                        </Col>
                                        <Col span={23}>
                                            <Checkbox
                                                value={
                                                    OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR
                                                        .TXT_EDITAR_NUMERO_DOCUMENTO_IDENTIDAD
                                                }
                                            >
                                                Editar Numero Documento Identidad
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="mantenimiento.usuario">Usuario</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="mantenimiento.rol">Rol</Checkbox>
                                        </Col>
                                        {campoSeccion !== undefined && campoSeccion.visible === true && (
                                            <Col span={24}>
                                                <Checkbox value="mantenimiento.seccion">Sección</Checkbox>
                                            </Col>
                                        )}
                                        {campoSubsede !== undefined && campoSubsede.visible === true && (
                                            <Col span={24}>
                                                <Checkbox value="mantenimiento.subsede">Subcentro de costo</Checkbox>
                                            </Col>
                                        )}
                                        {campoPerfil !== undefined && campoPerfil.visible === true && (
                                            <Col span={24}>
                                                <Checkbox value="mantenimiento.perfil">Perfil</Checkbox>
                                            </Col>
                                        )}
                                        {campoTipoPlanilla !== undefined && campoTipoPlanilla.visible === true && (
                                            <Col span={24}>
                                                <Checkbox value="mantenimiento.tipoPlanilla">Tipo Planilla</Checkbox>
                                            </Col>
                                        )}
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateNotificacion}
                                onChange={onCheckTodosNotificacion}
                                checked={checkAllNotificacion}
                                style={{ color: "#1678c1" }}
                            >
                                NOTIFICACIONES
                            </Checkbox>
                        </Row>
                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group
                                    value={opcionesSeleccionadasNotificaciones}
                                    onChange={onChangeOpcionNotificacion}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="notificacion.crear">
                                                Notificar Documentos Laborales
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="notificacion.seguimiento.formularios">
                                                Notificar Formularios
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="notificacion.comunicados.crear">
                                                Notificar comunicados
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="notificacion.evaluacion">Notificar Evaluación</Checkbox>
                                        </Col>
                                        {porCompletar && (
                                            <Col span={24}>
                                                <Checkbox value="notificacion.completar">
                                                    Notificación por Completar
                                                </Checkbox>
                                            </Col>
                                        )}
                                        {(getUsuarioAutenticado().subdominio.includes("ingenioti") ||
                                            getUsuarioAutenticado().subdominio.includes("antalis") ||
                                            getUsuarioAutenticado().subdominio.includes("demo")) && (
                                            <React.Fragment>
                                                <Col span={24}>
                                                    <Checkbox value="notificacion.firma-documento-generico">
                                                        Firma Documento Genérico
                                                    </Checkbox>
                                                </Col>
                                                <Col span={24}>
                                                    <Checkbox value="notificacion.firma-documento-generico.crear">
                                                        Crear Documentos Genéricos
                                                    </Checkbox>
                                                </Col>
                                                <Col span={24}>
                                                    <Checkbox value="notificacion.firma-documento-generico.listar">
                                                        Listar Documentos Genéricos
                                                    </Checkbox>
                                                </Col>
                                                <Col span={24}>
                                                    <Checkbox value="notificacion.firma-documento-generico.bandeja-aprobador">
                                                        Mis Documentos
                                                    </Checkbox>
                                                </Col>
                                            </React.Fragment>
                                        )}
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateContrato}
                                onChange={onCheckTodosContrato}
                                checked={checkAllContrato}
                                style={{ color: "#1678c1" }}
                            >
                                CONTRATO
                            </Checkbox>
                        </Row>
                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group
                                    value={opcionesSeleccionadasContratos}
                                    onChange={onChangeOpcionContrato}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="contrato.crear">Crear contrato</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="contrato.seguimiento">Seguimiento contrato</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="contrato.registrarPlantilla">Registrar Plantilla</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="explomin.contrato.seguimiento.administracionpersonal">
                                                Bandeja de Aprobación Administración Personal
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="explomin.contrato.seguimiento.rys">
                                                Bandeja de Aprobación Reclutamiento y Selección
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateLegajos}
                                onChange={onCheckTodosLegajos}
                                checked={checkAllLegajos}
                                style={{ color: "#1678c1" }}
                            >
                                CONSULTAR
                            </Checkbox>
                        </Row>
                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group value={opcionesSeleccionadasLegajos} onChange={onChangeOpcionLegajo}>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajos.consultas">Consultar Legajos</Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox
                                                value="notificacion.seguimiento.v2"
                                                onChange={onChangeSeleccionarSubMenu}
                                            >
                                                Notificaciones
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <div style={{ marginLeft: "20px" }}>
                                        <Checkbox.Group
                                            value={
                                                accionesSeleccionadas?.find(
                                                    (accion) => accion.opcionPadre === "notificacion.seguimiento.v2"
                                                )?.datos
                                            }
                                            onChange={(opciones) =>
                                                onChangeAccionesSeleccionadas(opciones, "notificacion.seguimiento.v2")
                                            }
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Checkbox
                                                        value={
                                                            OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES
                                                                .BOTON_VER_DETALLE
                                                        }
                                                        onChange={onChangeSeleccionarSubMenu}
                                                    >
                                                        Ver Detalle (Página)
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                            <div style={{ marginLeft: "20px" }}>
                                                <Checkbox.Group
                                                    value={
                                                        accionesSeleccionadas?.find(
                                                            (accion) =>
                                                                accion.opcionPadre ===
                                                                OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES
                                                                    .BOTON_VER_DETALLE
                                                        )?.datos
                                                    }
                                                    onChange={(opciones) =>
                                                        onChangeAccionesSeleccionadas(
                                                            opciones,
                                                            OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES
                                                                .BOTON_VER_DETALLE
                                                        )
                                                    }
                                                >
                                                    <Row>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={
                                                                    OPCIONES.PAGINA_DETALLE_NOTIFICACION
                                                                        .BOTON_VER_DOCUMENTO
                                                                }
                                                            >
                                                                Ver Documento (Botón)
                                                            </Checkbox>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={
                                                                    OPCIONES.PAGINA_DETALLE_NOTIFICACION
                                                                        .BOTON_REENVIAR_DOCUMENTO
                                                                }
                                                            >
                                                                Reenviar Documento (Botón)
                                                            </Checkbox>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={
                                                                    OPCIONES.PAGINA_DETALLE_NOTIFICACION
                                                                        .BOTON_ACTUALIZAR_CORREO
                                                                }
                                                            >
                                                                Actualizar Correo (Botón)
                                                            </Checkbox>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={
                                                                    OPCIONES.PAGINA_DETALLE_NOTIFICACION
                                                                        .BOTON_HISTORIAL_NOTIFICACION
                                                                }
                                                            >
                                                                Historial Notificación (Botón)
                                                            </Checkbox>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={
                                                                    OPCIONES.PAGINA_DETALLE_NOTIFICACION
                                                                        .BOTON_INHABILITAR_DOCUMENTO
                                                                }
                                                            >
                                                                Inhabilitar Documento (Botón)
                                                            </Checkbox>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Checkbox
                                                                value={
                                                                    OPCIONES.PAGINA_DETALLE_NOTIFICACION
                                                                        .BOTON_HABILITAR_DOCUMENTO
                                                                }
                                                            >
                                                                Habilitar Documento (Botón)
                                                            </Checkbox>
                                                        </Col>
                                                    </Row>
                                                </Checkbox.Group>
                                            </div>
                                            <Row>
                                                <Col span={24}>
                                                    <Checkbox
                                                        value={
                                                            OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES
                                                                .BOTON_GENERAR_REPORTE_EXCEL
                                                        }
                                                    >
                                                        Generar Reporte Excel (Botón)
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Checkbox
                                                        value={
                                                            OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES
                                                                .BOTON_GENERAR_REPORTE_PDF
                                                        }
                                                    >
                                                        Generar Reporte PDF (Botón)
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Checkbox
                                                        value={
                                                            OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES
                                                                .BOTON_ASIGNAR_CARPETA
                                                        }
                                                    >
                                                        Asignar Carpeta (Botón)
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Checkbox
                                                        value={
                                                            OPCIONES.PAGINA_CONSULTAR_POR_NOTIFICACIONES.BOTON_ELIMINAR
                                                        }
                                                    >
                                                        Eliminar Notificación (Botón)
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                        </Checkbox.Group>
                                    </div>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="consulta.documento" onChange={onChangeSeleccionarSubMenu}>
                                                Documentos
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div style={{ marginLeft: "20px" }}>
                                            <Checkbox.Group
                                                value={
                                                    accionesSeleccionadas?.find(
                                                        (accion) => accion.opcionPadre === "consulta.documento"
                                                    )?.datos
                                                }
                                                onChange={(opciones) =>
                                                    onChangeAccionesSeleccionadas(opciones, "consulta.documento")
                                                }
                                            >
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS
                                                                    .BOTON_VER_DOCUMENTO
                                                            }
                                                        >
                                                            Botón Ver Documento
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS
                                                                    .BOTON_REENVIAR_DOCUMENTO
                                                            }
                                                        >
                                                            Botón Reenviar Documento
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS
                                                                    .BOTON_ACTUALIZAR_CORREO
                                                            }
                                                        >
                                                            Botón Actualizar Correo
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS
                                                                    .BOTON_HISTORIAL_NOTIFICACION
                                                            }
                                                        >
                                                            Botón Ver Historial Notificación
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS
                                                                    .BOTON_INHABILITAR_DOCUMENTO
                                                            }
                                                        >
                                                            Botón Inhabilitar Documento
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_DOCUMENTOS
                                                                    .BOTON_HABILITAR_DOCUMENTO
                                                            }
                                                        >
                                                            Botón Habilitar Documento
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                            </Checkbox.Group>
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajo.v2.consultas" onChange={onChangeSeleccionarSubMenu}>
                                                Legajo del Colaborador
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div style={{ marginLeft: "20px" }}>
                                            <Checkbox.Group
                                                value={
                                                    accionesSeleccionadas?.find(
                                                        (accion) => accion.opcionPadre === "legajo.v2.consultas"
                                                    )?.datos
                                                }
                                                onChange={(opciones) =>
                                                    onChangeAccionesSeleccionadas(opciones, "legajo.v2.consultas")
                                                }
                                            >
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox
                                                            value={
                                                                OPCIONES.PAGINA_CONSULTAR_POR_CARPETAS
                                                                    .BOTON_VER_DOCUMENTO
                                                            }
                                                        >
                                                            Botón Ver Documento
                                                        </Checkbox>
                                                    </Col>
                                                </Row>
                                            </Checkbox.Group>
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajos.observacionesColaborador">
                                                Observaciones del Colaborador
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajos.consultaOnboarding">
                                                Bandeja de aprobacion
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajos.seguimientoOnboarding">
                                                Seguimiento Onboarding
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajos.reportes">Reportes</Checkbox>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                    <Col span={24}>
                      <Checkbox value="ausencias.solicitudes">Seguimiento Solicitudes</Checkbox>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <Checkbox value="vacaciones.control-vacacional">Control de vacaciones</Checkbox>
                    </Col>
                  </Row> */}
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="legajos.seguimientoEvaluaciones">
                                                Seguimiento Evaluaciones
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="consulta.seguimientoContrato">
                                                Seguimiento Contratos
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateConfiguracion}
                                onChange={onCheckTodosConfiguracion}
                                checked={checkAllConfiguracion}
                                style={{ color: "#1678c1" }}
                            >
                                CONFIGURACION
                            </Checkbox>
                        </Row>
                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group
                                    value={opcionesSeleccionadasConfiguracion}
                                    onChange={onChangeOpcionConfiguracion}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.formularios">Crear Formularios</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.misCertificados">Mis certificados</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.MiFirmaHolografa">
                                                Mis firmas hológrafas
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.certificadosDigitales">
                                                Certificados Digitales
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.tipoDocumentos">
                                                Crear Tipo Documento
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.carpetasLegajos">
                                                Crear Carpetas Legajos
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.verficarDatosColaborador">
                                                Verificar Datos Colaborador
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.plantillaEnvioDocumentos">
                                                Plantilla Envio Documentos
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.documentosSolicitables">
                                                Documentos Solicitables
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.onBoardingIndividual">
                                               OnBoarding Individual
                                            </Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.posicionesPdf">
                                                Configurar Posiciones PDF
                                            </Checkbox>
                                        </Col>
                                        {/* <Col span={24}>
                      <Checkbox value="configuracion.tipoAbsentismo">Tipo Absentismo</Checkbox>
                    </Col> */}
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateVacaciones}
                                onChange={onCheckTodosVacaciones}
                                checked={checkAllVacaciones}
                                style={{ color: "#1678c1" }}
                            >
                                VACACIONES
                            </Checkbox>
                        </Row>
                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group
                                    value={opcionesSeleccionadasVacaciones}
                                    onChange={onChangeOpcionVacaciones}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="configuracion.tipoAbsentismo">Tipo Absentismo</Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="ausencias.solicitudes">Seguimiento Solicitudes</Checkbox>
                                        </Col>
                                        <Col span={1}>
                                        </Col>
                                        <Col span={23}>
                                            <Checkbox
                                                value={
                                                    OPCIONES.PAGINA_VACACIONES_SEGUIMIENTO_SOLICITUDES.BOTON_CREAR_SOLICITUD
                                                }
                                            >
                                                Botón Crear Solicitud
                                            </Checkbox>
                                        </Col>
                                        <Col span={1}>
                                        </Col>
                                        <Col span={23}>
                                            <Checkbox
                                                value={
                                                    OPCIONES.PAGINA_VACACIONES_SEGUIMIENTO_SOLICITUDES.BOTON_EXPORTAR_SOLICITUDES
                                                }
                                            >
                                                Botón Exportar Solicitudes
                                            </Checkbox>
                                        </Col>
                                        <Col span={1}>
                                        </Col>
                                        <Col span={23}>
                                            <Checkbox
                                                value={
                                                    OPCIONES.PAGINA_VACACIONES_SEGUIMIENTO_SOLICITUDES.HABILITAR_RESTRICCIONES_SOLICITUDES
                                                }
                                            >
                                                Habilitar restricciones de solicitudes (bloqueo por fecha límite)
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="vacaciones.control-vacacional">
                                                Control de vacaciones
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="vacaciones.descanso-medico">
                                                Descanso Médico
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="programar.vacaciones">
                                                Programar Vacaciones
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="compra.vacaciones">
                                                Compra de Vacaciones
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                        <Divider />
                        <Row>
                            <Checkbox
                                indeterminate={indeterminateComunicacionCultura}
                                onChange={onCheckTodosComunicacionCultura}
                                checked={checkAllComunicacionCultura}
                                style={{ color: "#1678c1" }}
                            >
                                COMUNICACION Y CULTURA
                            </Checkbox>
                        </Row>
                        <Row>
                            <Col span={1}></Col>
                            <Col span={23}>
                                <Checkbox.Group
                                    value={opcionesSeleccionadasComunicacionCultura}
                                    onChange={onChangeOpcionComunicacionCultura}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Checkbox value="comunicacion-cultura.publicaciones">Publicaciones</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="comunicacion-cultura.reconocimientos">Reconocimientos</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="comunicacion-cultura.beneficios-externos">Beneficios Externos</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="comunicacion-cultura.puntos">Puntos</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="comunicacion-cultura.rendimiento">Rendimiento</Checkbox>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox value="comunicacion-cultura.beneficios">Beneficios</Checkbox>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Col>
                        </Row>
                    </Panel>
                </Collapse>
                <br />
                <Row justify="center">
                    <Space>
                        <Col>
                            <Form.Item style={{ textAlign: "center" }}>
                                <Button type="default" onClick={handleOnClickCancelar}>
                                    Cancelar
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item style={{ textAlign: "center" }}>
                                <Button type="primary" icon={<CheckOutlined />} loading={loading} htmlType="submit">
                                    Crear Rol
                                </Button>
                            </Form.Item>
                        </Col>
                    </Space>
                </Row>
            </Form>
        </ContainerCrear>
    );
}
